import { combineReducers } from 'redux-immutable';

import login from './login.duck';

export default combineReducers({
  login
});
